import Apify from '@module/apify';

export default Apify({
  getReceivedTransfers: {
    path: '/api/v4/received-transfers',
    method: 'GET',
  },

  getReceivedTransferById: {
    path: '/api/v4/received-transfers/{transferId}',
    pathExt: true,
    method: 'GET',
  },
});
